import { Lock, LockOpen } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '@/components/ui/alert-dialog';
import { useApuracaoSN } from '@/contexts';

export function FecharAbrirCompetenciaButton() {
  const { situacaoCompetencia, fecharCompetencia, abrirCompetencia, isFechando, isAbrindo } =
    useApuracaoSN();

  if (situacaoCompetencia === 'Aberto') {
    return (
      <Button
        size="sm"
        variant="outline"
        className="gap-2"
        onClick={fecharCompetencia}
        disabled={isFechando}
      >
        <Lock className="h-3.5 w-3.5" />
        {isFechando ? 'Fechando...' : 'Fechar Competência'}
      </Button>
    );
  }

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button size="sm" variant="outline" className="gap-2" disabled={isAbrindo}>
          <LockOpen className="h-3.5 w-3.5" />
          {isAbrindo ? 'Abrindo...' : 'Abrir Competência'}
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Tem certeza que deseja abrir o período?</AlertDialogTitle>
          <AlertDialogDescription>
            Ao abrir, documentos novos voltam a ser aceitos nesta competência e o recálculo passa a
            ficar liberado — o que pode mudar os valores já apurados.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancelar</AlertDialogCancel>
          <AlertDialogAction onClick={abrirCompetencia}>Abrir período</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
